/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * all unique beneficial owners of the company
 * @export
 * @interface UboDeclarationResponseUniqueBeneficialOwnersInner
 */
export interface UboDeclarationResponseUniqueBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    birthday: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    formattedBirthPlace: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    nationality: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    controlType: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseUniqueBeneficialOwnersInner
     */
    controlDetails: string;
}

/**
 * Check if a given object implements the UboDeclarationResponseUniqueBeneficialOwnersInner interface.
 */
export function instanceOfUboDeclarationResponseUniqueBeneficialOwnersInner(value: object): value is UboDeclarationResponseUniqueBeneficialOwnersInner {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('formattedBirthPlace' in value) || value['formattedBirthPlace'] === undefined) return false;
    if (!('nationality' in value) || value['nationality'] === undefined) return false;
    if (!('controlType' in value) || value['controlType'] === undefined) return false;
    if (!('controlDetails' in value) || value['controlDetails'] === undefined) return false;
    return true;
}

export function UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSON(json: any): UboDeclarationResponseUniqueBeneficialOwnersInner {
    return UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSONTyped(json, false);
}

export function UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationResponseUniqueBeneficialOwnersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'formattedAddress': json['formattedAddress'],
        'birthday': json['birthday'],
        'formattedBirthPlace': json['formattedBirthPlace'],
        'nationality': json['nationality'],
        'controlType': json['controlType'],
        'controlDetails': json['controlDetails'],
    };
}

export function UboDeclarationResponseUniqueBeneficialOwnersInnerToJSON(value?: UboDeclarationResponseUniqueBeneficialOwnersInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'formattedAddress': value['formattedAddress'],
        'birthday': value['birthday'],
        'formattedBirthPlace': value['formattedBirthPlace'],
        'nationality': value['nationality'],
        'controlType': value['controlType'],
        'controlDetails': value['controlDetails'],
    };
}

